import { GoogleGenerativeAI } from "@google/generative-ai";

let aiInstance: GoogleGenerativeAI | null = null;

export function getAI() {
  if (!aiInstance) {
    const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
    if (!apiKey) {
      throw new Error("Gemini API key is missing. Please add REACT_APP_GEMINI_API_KEY to your .env file.");
    }
    aiInstance = new GoogleGenerativeAI(apiKey);
  }
  return aiInstance;
}

export async function orchestrateAI(text: string, language: string, knowledgeBase: any[]) {
  const genAI = getAI();
  const model = genAI.getGenerativeModel({ model: "gemini-3-flash-preview" });

  // 1. PII Scrubbing (Frontend side)
  const scrubbedText = text.replace(/\d{12,16}/g, "[REDACTED_ACCOUNT]");

  // 2. Intent Detection & RAG Prompt
  const prompt = `
    You are the official MyBank Limited Virtual Assistant.
    User Language: ${language === "so" ? "Somali" : "English"}
    User Message: ${scrubbedText}
    
    Context from Knowledge Base:
    ${JSON.stringify(knowledgeBase.filter(k => k.language === language))}
    
    Instructions:
    - If the user is reporting a lost card or fraud, immediately respond with: "EMERGENCY_HANDOFF"
    - If the user wants to talk to a human, respond with: "HUMAN_HANDOFF"
    - Otherwise, answer the question using ONLY the provided context.
    - If the answer is not in the context, say you don't know and offer a human agent.
    - Keep it under 400 characters.
    - Use professional and helpful tone.
  `;

  const result = await model.generateContent(prompt);
  const response = await result.response;
  return response.text() || "I'm sorry, I couldn't process that.";
}
